import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { ConnectionModalState } from '../models';

@Injectable()
export class ConnectionsModalState {
	public activeComponent$: Observable<ConnectionModalState>;
	private activeComponent: Subject<ConnectionModalState>;

	public constructor() {
		this.activeComponent = new Subject();
		this.activeComponent$ = this.activeComponent.asObservable().pipe(distinctUntilChanged());
	}

	public setActive(props: ConnectionModalState) {
		this.activeComponent.next(props);
	}
}
